import styled, { css } from 'styled-components';
import Dropdown from 'react-bootstrap/Dropdown';
import { CampaignFieldStateProps } from 'models/campaign-mkt';

export const SelectLabel = styled.label`
  position: absolute;
  z-index: 2;
  top: 50%;
  left: 16px;
  max-width: calc(100% - 76px);
  padding: 0 3px;
  overflow: hidden;
  color: #6a6f77;
  background: #fbfbfb;
  font-family: 'Roboto Flex', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  white-space: nowrap;
  text-overflow: ellipsis;
  transform: translateY(-50%);
  transform-origin: left center;
  transition: top 120ms ease, font-size 120ms ease, color 120ms ease;
  pointer-events: none;
`;

const floatingLabel = css`
  top: 0;
  max-width: calc(100% - 36px);
  font-size: 12px;
  line-height: 16px;
`;

export const StyledDropdown = styled(Dropdown)<CampaignFieldStateProps>`
  position: relative;
  width: 100%;

  ${({ $filled }) =>
    $filled &&
    css`
      ${SelectLabel} {
        ${floatingLabel}
      }
    `}

  &.show ${SelectLabel} {
    ${floatingLabel}
  }

  &.show > .dropdown-toggle,
  &.show > .dropdown-toggle:hover,
  &.show > .dropdown-toggle:focus,
  &.show > .dropdown-toggle:active {
    border-color: ${({ $error }) =>
      $error ? '#d20003' : '#6a6f77'} !important;
    background: #fbfbfb !important;
    color: ${({ $error }) => ($error ? '#d20003' : '#33373c')} !important;
  }

  ${({ $error }) =>
    $error &&
    css`
      ${SelectLabel} {
        color: #d20003;
      }
    `}

  ${({ $disabled }) =>
    $disabled &&
    css`
      ${SelectLabel} {
        background: #f1f3f6;
        color: #9aa0a8;
      }
    `}

  .dropdown-toggle {
    width: 100%;
    height: 52px;
    margin: 0;
    padding: 14px 48px 12px 16px;
    overflow: hidden;
    border: 1px solid ${({ $error }) => ($error ? '#d20003' : '#6a6f77')};
    border-radius: 16px;
    background: #fbfbfb;
    box-shadow: none !important;
    color: ${({ $error }) => ($error ? '#d20003' : '#33373c')};
    font-family: 'Roboto Flex', sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:hover,
    &:focus,
    &:active {
      border-color: ${({ $error }) =>
        $error ? '#d20003' : '#6a6f77'} !important;
      background: #fbfbfb !important;
      color: ${({ $error }) => ($error ? '#d20003' : '#33373c')} !important;
    }

    &:disabled {
      border-color: #c7ccd3 !important;
      background: #f1f3f6 !important;
      color: #9aa0a8 !important;
      cursor: default;
      opacity: 1;
    }

    &::after {
      position: absolute;
      top: 50%;
      right: 18px;
      margin: 0;
      border-top: 8px solid currentColor;
      border-right: 6px solid transparent;
      border-left: 6px solid transparent;
      transform: translateY(-35%);
      transition: transform 120ms ease;
    }
  }

  &.show .dropdown-toggle::after {
    transform: translateY(-65%) rotate(180deg);
  }

  .dropdown-menu {
    width: 100%;
    max-height: 340px;
    margin-top: 8px;
    padding: 0;
    overflow-y: auto;
    border: 0;
    border-radius: 0;
    background: #f7f8fa;
    box-shadow: 0 6px 14px rgba(24, 39, 75, 0.12);
  }

  .dropdown-item {
    min-height: 56px;
    padding: 16px 18px;
    border-bottom: 1px solid #dce1e7;
    color: #33373c;
    font-family: 'Roboto Flex', sans-serif;
    font-size: 16px;
    line-height: 24px;
    white-space: normal;

    &:hover,
    &:focus,
    &:active {
      background: #edf1f6;
      color: #33373c;
    }
  }
`;
